module.exports = __webpack_public_path__ + "img/88.7c40d4e0.png";